import React, { useState } from "react";

import * as S from "./styles";
import { LoginBox } from "./styles";
import Logo from "../../assets/logoOrgannact.png";
import { Button, Input, Label } from "../main-styles";
import { useNavigate, useParams } from "react-router";
import { doLogin, requestPassword, resetPassword } from "../../api/auth";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { login } from "../../redux/slices/authSlice"; // Adjust the import path as necessary
import { Modal, ModalBody, ModalHeader, Spinner } from "reactstrap";
import { validateEmail } from "../../utils/shared-functions";

function ResetPassword() {
  const { token } = useParams();
  window.document.title = "Organnact - Redefinição de Senha";
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [state, setState] = useState({
    password: "",
    sending: false,
    email: "",
    new_password: "",
  });
  const { password, sending, new_password } = state;

  function updateState(field, value) {
    setState((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  }

  async function changePassword() {
    if (sending) return;
    if (!password || !new_password) {
      toast.error("Preencha todos os campos", {
        duration: 3000,
        position: "bottom-center",
      });
      return;
    }
    if (password !== new_password) {
      toast.error("As senhas não coincidem", {
        duration: 3000,
        position: "bottom-center",
      });
      return;
    }

    try {
      setState((s) => ({ ...s, sending: true }));
      const response = await resetPassword(password, token);
      console.log("response", response);
      toast.success("Senha alterada com sucesso", {
        duration: 3000,
        position: "bottom-center",
      });
      navigate("/");
    } catch (error) {
      console.error("Erro ao alterar senha:", error);
      toast.error('Ocorreu um erro ao alterar a senha, por favor, solicite um novo link de recuperação de senha.', {
        duration: 3000,
        position: "bottom-center",
      });
    } finally {
      setState((s) => ({ ...s, sending: false }));
    }
  }

  return (
    <S.Container>
      <LoginBox>
        <img src={Logo} alt="Organnact Logo" />
        <Label>Vamos definir uma nova senha</Label>
        <Label>Nova senha</Label>

        <Input
          type="password"
          value={password}
          onChange={(e) => setState({ ...state, password: e.target.value })}
        />
        <Label>Confirme a nova senha</Label>
        <Input
          type="password"
          value={new_password}
          onChange={(e) => setState({ ...state, new_password: e.target.value })}
        />
        <Button
          onClick={changePassword}
          disabled={!password || !new_password || sending}
          style={{ marginTop: 20 }}
        >
          {sending ? <Spinner size="sm" color="light" /> : "Redefinir Senha"}
        </Button>
      </LoginBox>
    </S.Container>
  );
}

export default ResetPassword;
